// src/hooks/useInfiniteScroll.js
import { useState, useEffect, useCallback, useRef } from 'react';

export const useInfiniteScroll = (fetchMore, hasMore, isLoading = false) => {
    const [isFetching, setIsFetching] = useState(false);
    const observerRef = useRef(null);
    // ⚠️ IMPORTANT: Utiliser useCallback pour que la ref soit mise à jour à chaque render
    const lastElementRef = useCallback((node) => {
        // Nettoyer l'ancien observer
        if (observerRef.current) {
            observerRef.current.disconnect();
        }
        
        if (!node) return;
        
        // Créer un nouvel observer pour le nouveau node
        observerRef.current = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                console.log('🔄 Intersection observée:', {
                    isIntersecting: entry.isIntersecting,
                    isFetching,
                    hasMore,
                    isLoading
                });
                
                if (entry.isIntersecting && !isFetching && hasMore && !isLoading) {
                    console.log('📥 Déclenchement du chargement...');
                    setIsFetching(true);
                }
            },
            { 
                threshold: 0.1,      // Déclencher quand 10% est visible
                rootMargin: '200px'  // Déclencher 200px avant d'atteindre
            }
        );
        
        observerRef.current.observe(node);
        console.log('👁️ Observateur attaché au nouveau node');
        
    }, [hasMore, isFetching, isLoading]);
    
    // Effet pour gérer le chargement
    useEffect(() => {
        if (isFetching && hasMore && !isLoading) {
            console.log('🚀 Appel de fetchMore...');
            fetchMore().finally(() => {
                console.log('✅ fetchMore terminé');
                setIsFetching(false);
            });
        }
    }, [isFetching, fetchMore, hasMore, isLoading]);
    
    // Nettoyage à la désactivation
    useEffect(() => {
        return () => {
            if (observerRef.current) {
                observerRef.current.disconnect();
                console.log('🧹 Observateur nettoyé');
            }
        };
    }, []);
    
    return { lastElementRef, isFetching };
};